import React from 'react'
import WarningPopup from '../WarningPopup'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'

interface IAspectRatioWarningPopupProps {
  isOpen: boolean
  pendingSelection: 'landscape' | 'portrait' | null
  onConfirm: () => void
  onCancel: () => void
}

const AspectRatioWarningPopup: React.FC<IAspectRatioWarningPopupProps> = ({
  isOpen,
  pendingSelection,
  onConfirm,
  onCancel
}) => {
  return (
    <WarningPopup
      isOpen={isOpen}
      title={
        pendingSelection === 'portrait'
          ? translate(T.SWITCH_TO_PORTRAIT_TITLE)
          : translate(T.SWITCH_TO_WIDESCREEN_TITLE)
      }
      warningText={
        <>
          <strong>Note:</strong>{' '}
          {translate(T.ASPECT_RATIO_WARNING_DESCRIPTION)
            .replace('Note:', '')
            .trim()}
        </>
      }
      confirmButtonText={translate(T.SWITCH_LABEL)}
      cancelButtonText={translate(T.CANCEL_LABEL)}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}

export default AspectRatioWarningPopup
